import React, { useState } from 'react';
import { api, errorText, tokens } from '../lib/api.js';
import { Alert, Field } from './ui.jsx';

/**
 * Changing your own password, on purpose rather than because you were made to.
 *
 * The endpoint has always existed; the only screen that called it was the one
 * shown when a temporary password had to be replaced. Once past that, nobody —
 * counter, accounts or the platform account — could ever change their password
 * again.
 */
export default function ChangePassword({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { setError('The two new passwords do not match'); return; }
    setBusy(true); setError(null);
    try {
      const res = await api.post('/api/auth/change-password', { current_password: current, new_password: next });
      // The change ends every session, this one included; without the fresh
      // tokens the next request would sign the person out.
      if (res && res.access_token) tokens.set({ ...tokens.get(), ...res });
      setDone(true);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="scrim" onClick={onClose}>
      <div className="palette" style={{ padding: 22 }} role="dialog" aria-label="Change password"
        onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 4px', fontSize: 18 }}>Change your password</h2>
        <p className="page-sub" style={{ marginBottom: 16 }}>
          Every session you have open elsewhere ends when it changes.
        </p>

        {done ? (
          <>
            <Alert kind="ok">Your password has been changed.</Alert>
            <button className="btn" style={{ marginTop: 12 }} onClick={onClose}>Close</button>
          </>
        ) : (
          <form onSubmit={submit}>
            <Alert>{error}</Alert>
            <Field label="Current password">
              <input type="password" value={current} autoFocus autoComplete="current-password"
                onChange={(e) => setCurrent(e.target.value)} required />
            </Field>
            <Field label="New password" hint="at least 10 characters">
              <input type="password" value={next} autoComplete="new-password" minLength={10}
                onChange={(e) => setNext(e.target.value)} required />
            </Field>
            <Field label="New password again">
              <input type="password" value={confirm} autoComplete="new-password" minLength={10}
                onChange={(e) => setConfirm(e.target.value)} required />
            </Field>
            <div className="inline" style={{ marginTop: 14 }}>
              <button className="btn" disabled={busy}>{busy ? 'Changing…' : 'Change password'}</button>
              <button type="button" className="btn ghost" onClick={onClose}>Cancel</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
